module.exports = __webpack_public_path__ + "static/media/eliza-jane.bb4c8feb.jpg";